import React, { useState, useEffect } from 'react';
import "./App.css";
import { BrowserRouter as Router, Route, Routes, BrowserRouter } from 'react-router-dom';
import Leaderboard from './components/leaderboard/leaderboard';
import NavBar from './components/navbar/nav';
import Footer from './components/footer/footer';
import ThankYouPage from './components/ThankYou/ThankYou';
import LeaderboardRules from "./components/rules/LeaderboardRules";
import Certificates from './pages/certificates';
import Home from "./components/home/home";
function App() {
  const [warning, setWarning] = useState('');

  useEffect(() => {
    
    const handleContextMenu = (event) => {
      event.preventDefault();
      setWarning('Data is protected');
      setTimeout(() => setWarning(''), 2000); // Remove warning after 2 seconds
    };

    // Function to restrict Ctrl+Shift+I (Developer Tools) and show warning
    const handleKeydown = (event) => {
      if (event.ctrlKey && event.shiftKey && event.key === 'I') {
        event.preventDefault();
        setWarning('Inspecting is disabled! Data is protected');
        setTimeout(() => setWarning(''), 2000); // Remove warning after 2 seconds
      }
      
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeydown);

    // Cleanup event listeners on component unmount
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);

  return (
    <>
      {/* Add a class to blur content when warning is active */}
      <div className={warning ? "blur-content" : ""}>
        <BrowserRouter>
          <NavBar />
          <Routes>
          <Route path="/leaderboard-marking-scheme" element={<LeaderboardRules />} />
          
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/genai-result" element={<ThankYouPage />} />
            <Route path="/certify" element={<Certificates/>} />
            <Route path="/" element={<Home/>} />

           
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>

      {/* Warning message in center */}
      {warning && <div className="warning">{warning}</div>}
    </>
  );
}

export default App;
